import ProjectForm from "../../components/user/ProjectForm/ProjectForm";
import UserTemplate from "../../views/UserTemplate";

const ProjectFormPage = () => {
  return (
    <UserTemplate>
      <ProjectForm />
    </UserTemplate>
  );
};

export default ProjectFormPage;
